module.exports = __webpack_public_path__ + "8b7d96776467b8c81fe72fd9398ffa1d.svg";